module.exports = __webpack_public_path__ + "img/arrow_left.ca43ba51.svg";